import { normalize } from 'normalizr';

import layoutSchema from '../schemas/layoutDataSchema';

let layoutKey = 0;
let adStateContainerKey = 0;

const getUniqueLayoutKey = () => (layoutKey += 1).toString();

const getUniqueAdStateContainerKey = () => (adStateContainerKey += 1).toString();

const createAdStateContainer = (thisAdStateContainer) => {
  const key = getUniqueAdStateContainerKey();
  const { artboard, dimensions, isFixed } = thisAdStateContainer;
  return {
    key,
    artboard,
    isFixed,
    dimensions,
  };
};

const extractPreviewAdStateContainers = (adStateContainers) => {
  const adStateContainerKeys = Object.keys(adStateContainers);

  return adStateContainerKeys.reduce((memo, key) => {
    const adStateContainer = adStateContainers[key];
    return [...memo, createAdStateContainer(adStateContainer)];
  }, []);
};

const createLayout = (layout) => {
  const adStateContainers = extractPreviewAdStateContainers(Object.values(layout.adStateContainers));
  const device = layout.device || 'desktop';
  const name = layout.name || '';
  const inApp = layout.inApp || false;
  const deviceHeader = layout.deviceHeader || 40;
  const background = layout.background || '';
  const backgroundFileName = layout.backgroundFileName || '';
  const backgroundAlign = layout.backgroundAlign || 'centre';
  const backgroundDimensions = layout.backgroundDimensions || [0, 0, 1, 1];
  const backgroundMonochrome = layout.backgroundMonochrome || false;
  const backgroundOpacity = layout.backgroundOpacity || 1;
  const isCustom = layout.isCustom || false;
  return {
    key: getUniqueLayoutKey(),
    id: layout.id,
    name,
    device,
    inApp,
    deviceHeader,
    background,
    backgroundFileName,
    backgroundAlign,
    backgroundDimensions,
    backgroundMonochrome,
    backgroundOpacity,
    adStateContainers,
    isCustom,
  };
};

const createNewLayoutConfiguration = (layoutConfiguration, viewport) => {
  const layoutKeys = Object.keys(layoutConfiguration);

  const transformedPreview = layoutKeys.map((layoutName, index) => {
    const thisLayout = layoutConfiguration[layoutName];
    const newAdStateContainer = createLayout(thisLayout, layoutName, viewport, index);
    return newAdStateContainer;
  });

  return transformedPreview;
};

export const parseLayouts = layoutData => createNewLayoutConfiguration(layoutData);

export const normalizeLayout = parsedLayoutData => normalize(parsedLayoutData, layoutSchema());



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/legacy/translator.js